module.exports = __webpack_public_path__ + "static/media/NewAppleWalletFullPhone.a965e1fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/NewAppleWalletFullPhone.png
// module id = 6121
// module chunks = 1